import { useTransactions } from '../api/transactions';
import { TransactionStatus } from '../common/transactions';

export interface UseContactTransactionHistoryProps {
    accountId?: number;
    cutoffTimeDeltaMs: number;
    contactId?: string | number | null;
    contactGroupId?: string | number | null;
    transactionStates?: Set<TransactionStatus> | TransactionStatus[];
}

function useContactTransactionHistory(props: UseContactTransactionHistoryProps) {
    const created_date_after = new Date();
    created_date_after.setMilliseconds(created_date_after.getMilliseconds() - props.cutoffTimeDeltaMs);
    // Set hours, minutes, seconds and ms to 0 to make caching work correctly, otherwise this would always cause a refetch.
    created_date_after.setHours(0);
    created_date_after.setMinutes(0);
    created_date_after.setSeconds(0);
    created_date_after.setMilliseconds(0);

    let transactionStates = props.transactionStates || TransactionStatus.delivered_states_set().union(TransactionStatus.received_states_set());

    return useTransactions(
        {
            account: props.accountId ? props.accountId.toString() : undefined,
            status: transactionStates,
            sender: props.contactId ? props.contactId.toString() : undefined,
            receiver: props.contactId ? props.contactId.toString() : undefined,
            sender_group: props.contactGroupId ? props.contactGroupId.toString() : undefined,
            receiver_group: props.contactGroupId ? props.contactGroupId.toString() : undefined,
            created_date_after: created_date_after.toISOString(),
        },
        { enabled: !!props.contactId || !!props.contactGroupId }
    );
}

export default useContactTransactionHistory;
